import { Box, Button, LinearProgress, Typography } from '@mui/material';
import React from 'react';

interface FetchMorePaginatorProps {
    fetchMore: () => void;
    label: string;
    showingCurrent: number;
    totalCount: number;
    hasNextPage: boolean;
    displayShowMoreButton: boolean;
    displayCount?: boolean;
}

const FetchMorePaginator = ({
    fetchMore,
    label,
    showingCurrent,
    totalCount,
    hasNextPage,
    displayShowMoreButton = true,
    displayCount = true,
}: FetchMorePaginatorProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        {displayCount ? (
            <Typography
                className="showingArticlesNumber"
                variant="caption"
                sx={{
                    color: 'text.secondary',
                }}
            >
                Showing {showingCurrent} of {totalCount} {label}
            </Typography>
        ) : null}
        {hasNextPage && (
            <>
                <Box sx={{ width: 120, mt: 1, mb: 2 }}>
                    <LinearProgress
                        className="progressBar"
                        variant="determinate"
                        value={
                            totalCount ? (showingCurrent / totalCount) * 100 : 0
                        }
                    />
                </Box>
                {displayShowMoreButton ? (
                    <Button
                        className="showMoreArticlesButton"
                        variant="contained"
                        onClick={fetchMore}
                    >
                        Show more {label}
                    </Button>
                ) : null}
            </>
        )}
    </Box>
);

export default FetchMorePaginator;
